import { prepHandleEvent } from "./prepHandleEvent";
import { QKeyBoardInfo } from "../CoreApp/QKeyboardInfo.js";

export function handleMobileKeyboardInput(event) {
  var canvasElement = document.getElementById("basecanvas");
  var myApp = prepHandleEvent(canvasElement, false, null, null);
  if (myApp == null) {
    return;
  }
  var data = event.data;
  if (data == null) return;

  var softKeyboardInfo = new QKeyBoardInfo();
  softKeyboardInfo.charCode = data.charCodeAt(0);
  var handled = myApp.HandleMobileKeyboard(event, softKeyboardInfo);
  if (handled) {
    // Prevent tab key from being handled by browser
    event.preventDefault();
  }
}
